// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1VQjv","header":"styles_header__1A_pB","back":"styles_back__A2Kew","title":"styles_title__akZBK","content":"styles_content__xQlTs"};